import {
  SET_SELECTED_STATUS_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_EMPRESA_ACTION,
  SET_CENTRO_CUSTO_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_RESPONSAVEL_ACTION,
  SET_FORNECEDOR_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_INICIAL_ACTION,
  SET_GRUPO_ACTION,
  SET_LOCAL_ENTREGA_ACTION,
  SET_SITUACAO_ACTION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  RESET_PAGINATION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from './actions.type';
import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_CENTRO_CUSTO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_FORNECEDOR,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_GRUPO,
  SET_LOCAL_ENTREGA,
  SET_SITUACAO,
  SET_CURRENT_PAGE,
  SET_OFFSET,
  SET_FILTER,
  SET_LIST_OPTIONS,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_LOCAL_ENTREGA_ACTION](context, localEntrega) {
    context.commit(SET_LOCAL_ENTREGA, localEntrega);
  },
  [SET_CENTRO_CUSTO_ACTION](context, centroCusto) {
    context.commit(SET_CENTRO_CUSTO, centroCusto);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_RESPONSAVEL_ACTION](context, responsavel) {
    context.commit(SET_RESPONSAVEL, responsavel);
  },
  [SET_FORNECEDOR_ACTION](context, fornecedor) {
    context.commit(SET_FORNECEDOR, fornecedor);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
  [SET_GRUPO_ACTION](context, grupo) {
    context.commit(SET_GRUPO, grupo);
  },
  [SET_SITUACAO_ACTION](context, situacao) {
    context.commit(SET_SITUACAO, situacao);
  },
  [RESET_PAGINATION](context) {
    context.commit(SET_CURRENT_PAGE, 1);
    context.commit(SET_OFFSET, 0);
  },
  [SET_FILTER_ACTION](context, filter) {
    context.commit(SET_FILTER, filter);
  },
  [SET_LIST_OPTIONS_ACTION](context, listOptions) {
    context.commit(SET_LIST_OPTIONS, listOptions);
  },
  [SET_CURRENT_SESSION_STATE_ACTION](context, ids) {
    context.commit(SET_CURRENT_SESSION_STATE, ids);
  },
  [INIT_STATE_ACTION](context, ids) {
    context.commit(INIT_STATE, ids);
  },
};
